<template>
  <div class="file-upload-container">
    <v-row>
      <v-col cols="12" md="6">
        <v-file-input
          label="1. Upload Old Excel File"
          accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          prepend-icon="mdi-file-excel"
          :disabled="disabled"
          @change="handleOldFileUpload"
          :value="oldFile"
          outlined
        />
      </v-col>
      
      <v-col cols="12" md="6">
        <v-file-input
          label="2. Upload New Excel File"
          accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
          prepend-icon="mdi-file-excel"
          :disabled="disabled"
          @change="handleNewFileUpload"
          :value="newFile"
          outlined
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div class="button-group d-flex flex-wrap gap-2">
      <v-btn
        @click="$emit('process-files')"
        :disabled="!oldFile || !newFile || disabled"
        color="primary"
        :loading="isProcessing"
      >
        <v-icon left>mdi-play</v-icon>
        {{ isProcessing ? 'Processing...' : 'Process Files' }}
      </v-btn>
      
      <v-btn
        @click="$emit('export-output')"
        :disabled="!hasComparisonData || isExporting"
        color="success"
        :loading="isExporting"
      >
        <v-icon left>mdi-download</v-icon>
        {{ isExporting ? 'Exporting...' : 'Export Output Excel' }}
      </v-btn>
      
      <v-btn
        @click="$emit('reset')"
        :disabled="disabled"
        color="error"
        outlined
      >
        <v-icon left>mdi-close</v-icon>
        Reset
      </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'FileUpload',
  props: {
    oldFile: {
      type: Object,
      default: null
    },
    newFile: {
      type: Object,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isProcessing: {
      type: Boolean,
      default: false
    },
    hasComparisonData: {
      type: Boolean,
      default: false
    },
    isExporting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['old-file-upload', 'new-file-upload', 'process-files', 'export-output', 'reset'],
  methods: {
    handleOldFileUpload(file) {
      if (file && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls') || file.type.includes('spreadsheet') || file.type.includes('excel'))) {
        this.$emit('old-file-upload', file)
      }
    },
    handleNewFileUpload(file) {
      if (file && (file.name.endsWith('.xlsx') || file.name.endsWith('.xls') || file.type.includes('spreadsheet') || file.type.includes('excel'))) {
        this.$emit('new-file-upload', file)
      }
    }
  }
}
</script>

<style scoped>
.file-upload-container {
  margin-bottom: 24px;
}

.button-group {
  gap: 12px;
}

.button-group .v-btn {
  margin-right: 8px;
  margin-bottom: 8px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .button-group {
    flex-direction: column;
    align-items: stretch;
  }
  
  .button-group .v-btn {
    margin-right: 0;
    width: 100%;
  }
}
</style>
